import type { SupportedAlpha2CountryCode } from '@/lib/utils/localization/getSupportedAlpha2CountryCodes'
import getPlatform from '@/lib/utils/shared/getPlatform'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'
import type { SupportedLocale } from '@/lib/utils/localization/getFlattenedLocales'

export type HydraCreateAccountProps = {
  firstName: string
  lastName: string
  email: string
  password: string
  phoneNumber: string
  country: SupportedAlpha2CountryCode
  referralId?: string | null
  version: string // apps version
  recaptchaToken: string
  locale: SupportedLocale
  state?: string
  marketoSmsOptIn?: boolean
  privacyPolicy?: boolean
}

export type HydraCreateAccountResponse = {
  email: string
  enroller: {
    href: string
    id: {
      unicity: number
    }
  }
  homePhone: string
  humanName: {
    firstName: string
    lastName: string
  }
  mainAddress: {
    country: string
    address1: string
    address2: string
    city: string
    state: string
    zip: string
  }
  mobilePhone: string
  password: {
    value: string
  }
  source: {
    agent: string
    campaign: null | string
    medium: null | string
    platform: string
    referrer: null | string
    version: string
  }
  sponsor: {
    href: string
    id: {
      unicity: number
    }
  }
  type: string
  programEnrollments: string[]
  status: string
  id: {
    unicity: string
  }
  href: string
}

export const HydraCreateAccount = ({
  firstName,
  lastName,
  email,
  password,
  phoneNumber,
  // privacyPolicy,
  country,
  referralId,
  version,
  recaptchaToken,
  locale,
  state,
  marketoSmsOptIn = false,
}: HydraCreateAccountProps) => {
  const referralLink = referralId
    ? `${process.env.NEXT_PUBLIC_HYDRA_BASE_URL}/customers?id.unicity=${referralId}`
    : null

  const requestBody = {
    // ...(privacyPolicy && {
    //   rights: [
    //     {
    //       holder: 'Unicity',
    //       type: 'SendEmails',
    //     },
    //     {
    //       holder: 'Upline',
    //       type: 'SendEmails',
    //     },
    //   ],
    // }),
    email,
    type: referralId ? 'Member' : 'Customer',
    mainAddress: {
      country,
      ...(state && { state }),
    },
    humanName: {
      firstName,
      lastName,
    },
    mobilePhone: phoneNumber,
    homePhone: phoneNumber,
    preferredLocale: locale,
    password: {
      value: password,
    },
    source: {
      agent: 'Shop2.0',
      platform: getPlatform(),
      version,
    },
    recaptchaType: 'invisible',
    ...(marketoSmsOptIn && {
      programEnrollments: ['SMSOptIn'],
    }),
    ...(referralLink && {
      sponsor: {
        href: referralLink,
      },
      enroller: {
        href: referralLink,
      },
    }),
    recaptchaToken,
  }

  const request: SendRequestType = {
    method: 'POST',
    url: '/customers',
    withAuth: false,
    data: requestBody,
  }

  return httpTools.sendRequest<HydraCreateAccountResponse>(request)
}
